'use client';

import PlayArrowRoundedIcon from '@mui/icons-material/PlayArrowRounded';
import StopRoundedIcon from '@mui/icons-material/StopRounded';
import {
  Checkbox,
  FormControlLabel,
  FormGroup,
  IconButton,
  Tooltip,
  type SxProps,
} from '@mui/material';
import { flatSx, FlexColumn, FlexRow, StackRow } from '@ocodelib/mui';
import { useObservable } from '@ocodelib/mui/hooks';
import { IframeMonacoEditorWrapper } from '../../iframes/IframeMonacoEditorWrapper';
import { useJsBasicApp } from '../../useJsBasicApp';

interface Props {
  sx?: SxProps;
}

export function CodeEditorBox(props: Props) {
  const { sx } = props;
  const { appManager, app } = useJsBasicApp();
  const { datiBaseURL } = appManager.appConfig;

  return (
    <FlexColumn
      alignItems="stretch"
      className="CodeEditorBox-root"
      sx={flatSx(
        {
          position: 'relative',
          width: '100%',
          height: '100%',
          '& .CodeEditorBox-editor': {
            flex: 1,
          },
        },
        sx,
      )}
    >
      <CodeEditorTop />

      <IframeMonacoEditorWrapper
        className="CodeEditorBox-editor"
        datiBaseURL={datiBaseURL}
        onLoadEditor={(editor) => {
          if (!editor) return;
          app.setupCodeEditor(editor);
        }}
      />
    </FlexColumn>
  );
}

function CodeEditorTop() {
  const { app } = useJsBasicApp();
  const editor = useObservable(app.editor$);
  const autoRefreshEnabled = useObservable(app.autoRefreshEnabled$);

  const handleClickPlay = () => {
    app.renderSketch();
  };

  const handleClickStop = () => {
    app.stopSketch();
  };

  return (
    <FlexRow.Start alignItems="center" sx={{ bgcolor: '#edeff1', height: 40, pl: 1 }}>
      {editor && (
        <StackRow alignItems="center" spacing={0.5} sx={{ ml: 'auto' }}>
          <FormGroup>
            <FormControlLabel
              control={
                <Checkbox
                  checked={autoRefreshEnabled ?? false}
                  onChange={(_, checked) => {
                    app?.setAutoRefreshEnabled(checked);
                  }}
                  size="small"
                />
              }
              label="자동 실행"
            />
          </FormGroup>

          <Tooltip title="Run">
            <IconButton onClick={handleClickPlay} color="secondary" size="small">
              <PlayArrowRoundedIcon />
            </IconButton>
          </Tooltip>
          <Tooltip title="Stop">
            <IconButton onClick={handleClickStop} color="primary" size="small">
              <StopRoundedIcon />
            </IconButton>
          </Tooltip>
        </StackRow>
      )}
    </FlexRow.Start>
  );
}
